import {Subject} from 'rxjs';
import {PlayingState, Seekable} from './playable';

export class Mp4 implements Seekable {
  playingState$ = new Subject<PlayingState>();
  currentTime$ = new Subject<number>();
  totalTime$ = new Subject<number>();
  loading$ = new Subject<number>();
  stats$ = new Subject<any>();
  log$ = new Subject<any>();

  isSeekable = true;
  protected video: HTMLVideoElement;
  private pauseCalled = false;
  private deb;

  constructor() {
    this.playingState$.next(PlayingState.STOPPED);
  }

  get isPlaying() {
    return !this.video.paused;
  }

  get hasStarted() {
    return this.isPlaying && this.video.currentTime > 0;
  }

  get source() {
    return this.video.src;
  }

  attachMedia(video: HTMLVideoElement) {
    this.video = video;

    this.attachEvents();
  }

  loadSource(src: string) {
    this.video.src = src;
  }

  play() {
    let promise = this.video.play();
    if (promise && promise.catch) {
      promise.catch(e => {
        if (e.code == 20 && !this.pauseCalled) {
          console.log('Can\'t play, restarting:', e.message);
          return this.play();
        } else {
          console.log('Can\'t play:', e.message);
          this.stop();
        }
      });
    }

    promise.then(() => this.pauseCalled = false);
    return promise;
  }

  stop() {
    this.pauseCalled = true;
    this.video.pause();
  }

  setVolume(value: number) {
    this.video.volume = value / 100;
  }

  seek(position: number) {
    this.video.currentTime = position;
    this.updateCurrentTime();
  }

  destroy() {
    this.stop();
  }

  protected attachEvents() {
    this.addListeners(['play', 'playing', 'suspend', 'abort', 'ended', 'pause'], this.updateState);
    this.addListeners(['timeupdate', 'loadedmetadata'], this.updateCurrentTime);
  }

  protected updateState(event) {
    this.playingState$.next(this.getPlayingState());
  }

  protected updateCurrentTime() {
    if (this.deb) {
      return false;
    }

    this.currentTime$.next(this.video.currentTime || 0);
    this.totalTime$.next(this.video.duration || 0);

    this.deb = true;
    setTimeout(() => this.deb = false, 300);
  }

  protected buffer() {
    let video = this.video;
    return video.currentTime && video.buffered.length ? Math.round(video.buffered.end(video.buffered.length - 1) - video.currentTime) : 0;
  }

  private getPlayingState() {
    if (!this.isPlaying) {
      return PlayingState.PAUSED;
    }
    if (!this.hasStarted) {
      return PlayingState.PLAYING;
    }
    if (this.hasStarted) {
      return PlayingState.STARTED;
    }
  }

  private addListeners(events: string[], callback) {
    events.forEach(event => this.video.addEventListener(event, callback.bind(this)));
  }


}
